import { AuthContextImplementation } from './AuthContextType';

const DOMAIN = `${window.location.protocol}//${window.location.host}`;
const LOGIN_URL = `${DOMAIN}/helios-api/auth0/login?ui_request=true`;
const LOGOUT_URL = `${DOMAIN}/helios-api/auth0/logout?ui_request=true`;

export const Auth0Context = (): AuthContextImplementation => {
    const goToLogin = (path = '/') => {
        const state = crypto.randomUUID();
        sessionStorage.setItem(state, path);
        window.location.href = `${LOGIN_URL}&state=${state}`;
    };

    return {
        goToLogin,
        logout: () => (window.location.href = LOGOUT_URL),
    };
};
